import { render, staticRenderFns } from "./OutlineArrow.vue?vue&type=template&id=ec97fe66&"
import script from "./OutlineArrow.vue?vue&type=script&lang=js&"
export * from "./OutlineArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports